import React from 'react';
import Slider from 'rc-slider';
import 'rc-slider/assets/index.css';

const PriceRangeSlider = ({ min, max, value, onChange }) => {
  return (
    <div style={{ padding: '0 8px' }}>
      <Slider
        range
        min={min}
        max={max}
        value={value}
        onChange={onChange}
        allowCross={false}
        trackStyle={[{ backgroundColor: '#3b82f6' }]}
        handleStyle={[
          { borderColor: '#3b82f6', backgroundColor: '#fff' },
          { borderColor: '#3b82f6', backgroundColor: '#fff' }
        ]}
        railStyle={{ backgroundColor: '#e5e7eb' }}
      />
      <div className="flex justify-between text-xs mt-2 text-slate-600">
        <span>{min}</span>
        <span>{max}</span>
      </div>
    </div>
  );
};

export default PriceRangeSlider;
